<template>
	<div v-if="listItems.length" class="list">
		<p v-if="title?.length" class="subtitle pointer" @click="toggleList">{{ title }} <i class="fas" :class="showList ? 'fa-caret-down' : 'fa-caret-up'"></i></p>
		<div
			v-show="showList"
			class="list-item"
			v-for="item in listItems"
			:key="item.id"
		>
			<div class="row" :class="minimizedListsCountWithElements(sublists) ? 'pointer' : ''" @click="toggleSublist(item.id)">
				<p class="move-type-box">{{ getMoveType(item.moveType) }}</p>
				<p class="list-item-text">{{ getDisplayName(item, displayName) }} <i v-if="minimizedListsCountWithElements(sublists)" class="fas" :class="showSubList(item.id) ? 'fa-caret-down' : 'fa-caret-up'"></i></p>
			</div>
			<div v-show="showSubList(item.id)" class="sublist" v-for="sublist in sublists" :key="'sublist' + sublist.title">
				<SummaryList
					:startCollapsed="sublist.collapsedSublist"
					:title="sublist.title"
					:listItems="item[sublist.sublistName]"
					:displayName="sublist.sublistItemName"
					:sublists="sublist.sublists"
					:moveStatus="moveStatus"
				/>
			</div>
			<div class="collapse-text" v-show="!showSubList(item.id) && minimizedListsCountWithElements(sublists)">
				{{ minimizedListsCountWithElements(sublists) }} {{ minimizedListsCountWithElements(sublists) > 1 ? $t('summary_list.collapsed_categories_plural') : $t('summary_list.collapsed_categories_singular') }}
			</div>
		</div>
		<div class="collapse-text" v-if="collapseList">
			<p>
				{{ listItems.length }} {{ listItems.length > 1 ? $t('summary_list.collapsed_rows_plural') : $t('summary_list.collapsed_rows_singular') }}
			</p>
		</div>
	</div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
	name: 'SummaryList',
	props: {
		listItems: Array,
		title: String,
		displayName: {
			type: String,
			default: 'name'
		},
		sublists: {
			type: Array
		},
		startCollapsed: Boolean,
		moveStatus: Number
	},
	data() {
		return {
			collapseList: false,
			collapsedSublists: []
		};
	},
	computed: {
		...mapGetters('appStore', ['isMobile']),
		showList() {
			return this.listItems.length && !this.collapseList ? true : false;
		}
	},
	methods: {
		minimizedListsCountWithElements(lists) {
			let totalCount = 0;
			
			if (!lists) return totalCount;
			
			lists.forEach(list => {
				totalCount += list.length;
			});
			
			return totalCount;
		},
		toggleList() {
			this.collapseList = !this.collapseList;
		},
		toggleSublist(id) {
			let foundIdIndex = this.collapsedSublists.findIndex(collapseId => collapseId === id);
			
			if (foundIdIndex < 0) {
				this.collapsedSublists.push(id);
			} else {
				this.collapsedSublists.splice(foundIdIndex, 1);
			}
		},
		showSubList(id) {
			let foundIdIndex = this.collapsedSublists.findIndex(collapseId => collapseId === id);
			
			if (foundIdIndex >= 0) {
				return false;
			} else {
				return true;
			}
		},
		getDisplayName(item, displayName) {
			if (item.firstName && item.lastName) {
				return `${item.firstName} ${item.lastName}`;
			}
			
			return item[displayName];
		},
		getMoveType(moveTypeNumber) {
			let moveStarted = this.moveStatus > 0;

			switch (moveTypeNumber) {
				case 0:
					return this.$t(moveStarted ? 'summary_list.copied' : 'summary_list.copy');
				case 1:
					return this.$t(moveStarted ? 'summary_list.moved' : 'summary_list.move');
				case 2:
					return this.$t(moveStarted ? 'summary_list.replaced' : 'summary_list.replace');
				case 3:
					return this.$t(moveStarted ? 'summary_list.ignored' : 'summary_list.ignore');
				case 4:
					return this.$t(moveStarted ? 'summary_list.cross_connected' : 'summary_list.cross_connect');
			}
			return '';
		}
	},
	created() {
		if (this.startCollapsed) {
			this.collapsedSublists = this.listItems.map(x => x.id);
		}
	}
};
</script>

<style lang="scss" scoped>
@import "@/assets/colors.scss";

.list, .sublist {
	margin-top: 0.5rem;
	border-bottom: 1px solid #e7e7e7;
	.list-item {
		margin-left: 0.25rem;
		margin-bottom: 0.25rem;
		&:not(:last-child) {
				border-bottom: 1px solid #eeeeee;
		}
		
		.row {
			margin-bottom: 0.25rem;
			display: flex;
		}
		
		.list-item-text {
				padding: 2px;
				margin-right: 0.5rem;
		}
	}
	
	.subtitle {
		margin-bottom: 0.1rem;
		font-size: 16px;
		font-weight: 600;
	}
}

.sublist {
	border-bottom: none;
	margin-left: 1rem;
}

.pointer {
	cursor: pointer;
}

.move-type-box {
	margin-right: 0.25rem;
	padding: 2px 0.25rem;
	background: $dark;
	color: white;
	border: 1px solid #eeeeee;
	max-height: 30px;
}

.collapse-text {
	margin-left: 1rem;
	min-height: 34px;
	display: flex;
	flex-direction: column;
	justify-content: center;
}
</style>